import { MinProductItemProps } from "./constants";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import HorizontalProduct from "./HorizontalProduct";
import Link from "next/link";
import Cookies from "js-cookie";

import "swiper/css";
import "swiper/css/pagination";


interface SlideFocusProductProps {
  title: string;
  link: string;
  link_name: string;
  products: Array<MinProductItemProps>;
}

const SlideFocusProduct = (props: SlideFocusProductProps) => {
  const viewport = Cookies.get('viewport');

  if (props.products.length === 0) {
    return (<></>)
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <p className="text-base font-bold text-black">{props.title}</p>
        <div>
          <Link href={props.link}>
            <p className="text-xs text-mooimom underline">{props.link_name}</p>
          </Link>
        </div>
      </div>
      <Swiper
        spaceBetween={0}
        centeredSlides={false}
        loop={true}
        slidesPerView={viewport === "desktop" ? 2 : 1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        pagination={{
          clickable: true,
          enabled: true,
        }}
        modules={[Autoplay, Pagination]}
        className="review-swiper !pb-8"
      >
        {props.products.flatMap((product, index) => {
          if (index % 2 === 0 && props.products[index + 1]) {
            return (
              <SwiperSlide key={index} className="space-y-4">
                <HorizontalProduct product={product} fullWidth={false}  />
                <HorizontalProduct product={props.products[index + 1]} fullWidth={false} />
              </SwiperSlide>
            )
          }
        })}
        {props.products.length === 1 && (
          <SwiperSlide>
            <HorizontalProduct product={props.products[0]} fullWidth={true} />
          </SwiperSlide>
        )}
      </Swiper>
    </div>
  )
}

export default SlideFocusProduct
